export default __webpack_public_path__ + "static/flag-be-c4f48830300360022d687e26149414da.svg";